module.exports = __webpack_public_path__ + "static/media/plus.fb379d11.svg";